const doc = [({"en":({"js":({"admin":({"activities":({"create_card":({"expandable_content":({"required_metadata_on_sign_up":"Sign up - Required meta data"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;